import { _ as a } from "./index.es410.js";
import { _ as t } from "./index.es411.js";
var s = a, n = t;
function _(e, r) {
  return r.length < 2 ? e : s(e, n(r, 0, -1));
}
var m = _;
export {
  m as _
};
//# sourceMappingURL=index.es273.js.map
